import React from "react";

import { CreateServiceAccountKeyForm } from "./create";
import { ServiceAccountKeyCreateSucceeded } from "./create-succeeded";
import { ServiceAccountKeysList } from "./list";

import type {
  ServiceAccount,
  ServiceAccountKey,
} from "../../../../../../application/domain/service-account/service-account";

type Props = {
  serviceAccount: ServiceAccount;
  serviceAccountKeys: ServiceAccountKey[];

  onClickCreate: (
    param: { expiredAtUnixMilliSecond: number; name: string },
    callback: {
      onSucceeded: (newKey: ServiceAccountKey, privateKeyPem: string) => void;
      onFailed: (errorMessage: string) => void;
    },
  ) => void;
  onClickDisableServiceAccountKey?: (
    param: { serviceAccountKeyId: ServiceAccountKey["id"] },
    callback: {
      onSucceeded: () => void;
      onFailed: (errorMessage: string) => void;
    },
  ) => void;
};

export const ServiceAccountKeys: React.FC<Props> = ({
  serviceAccount,
  serviceAccountKeys,
  onClickCreate,
  onClickDisableServiceAccountKey,
}) => {
  const [viewState, setViewState] = React.useState<
    "list" | "create" | "createSucceeded"
  >("list");

  const [formDisabled, setFormDisabled] = React.useState<boolean>(false);
  const [createSucceededProps, setCreateSucceededProps] =
    React.useState<
      Pick<
        React.ComponentProps<typeof ServiceAccountKeyCreateSucceeded>,
        "serviceAccountKey" | "privateKeyPem"
      >
    >();

  return (
    <>
      {viewState === "list" && (
        <ServiceAccountKeysList
          serviceAccount={serviceAccount}
          serviceAccountKeys={serviceAccountKeys}
          onClickStartCreate={() => {
            setViewState("create");
          }}
          onClickDisableServiceAccountKey={onClickDisableServiceAccountKey}
        />
      )}
      {viewState === "create" && (
        <CreateServiceAccountKeyForm
          onClickCancel={() => {
            setViewState("list");
          }}
          onClickCreate={(param) => {
            setFormDisabled(true);

            onClickCreate(param, {
              onSucceeded: (serviceAccountKey, privateKeyPem) => {
                setCreateSucceededProps({
                  serviceAccountKey,
                  privateKeyPem,
                });
                setViewState("createSucceeded");
                setFormDisabled(false);
              },
              onFailed: (errorMessage) => {
                alert(`エラーが発生しました: ${errorMessage}`);
                setFormDisabled(false);
              },
            });
          }}
          disabled={formDisabled}
        />
      )}
      {viewState === "createSucceeded" && createSucceededProps && (
        <ServiceAccountKeyCreateSucceeded
          serviceAccountKey={createSucceededProps.serviceAccountKey}
          privateKeyPem={createSucceededProps.privateKeyPem}
          onClickToList={() => {
            setViewState("list");
            setCreateSucceededProps(undefined);
          }}
        />
      )}
    </>
  );
};
